import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  appDrawerOpen: true,
  errorModalOpen: false,
  errorModalBody: "",
  mode: "production",
  running: false,
  lastRebuildDt: ""
});

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.APP_SET_REBUILD_STATUS:
      return state.merge(action.payload);
    case types.APP_SET_MODE:
      return state.set("mode", action.payload);
    case types.APP_DRAWER_TOGGLE:
      return state.set("appDrawerOpen", action.payload);

    case types.ERROR_MODAL_OPEN:
      return state.set("errorModalOpen", true);

    case types.ERROR_MODAL_CLOSE:
      return state.set("errorModalOpen", false);

    case types.ERROR_MODAL_SET_BODY:
      return state.set("errorModalBody", action.payload);

    default:
      return state;
  }
};

export default uiReducer;
